import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import NavBar from '../Components/Main/NavBar';

const PaymentReview = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const tranCode = params.get('TranCode');
  const orderId = params.get('OrderID');
  const approvalCode = params.get('ApprovalCode');
  const totalAmountRaw = params.get('TotalAmount');
  const currency = params.get('Currency') || 'HUF';

  const totalAmount = totalAmountRaw
    ? Number(totalAmountRaw) / 100
    : 0;

  useEffect(() => {
    if (tranCode !== '000') return; // csak sikeres fizetés

    const transactionId = approvalCode || orderId || '';

    const alreadyTracked = sessionStorage.getItem('purchase_tracked');
    if (alreadyTracked === transactionId) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'adkkez_visszig_Fizetés', // EZ FONTOS
      value: totalAmount,
      transaction_id: transactionId,
      currency: currency
    });

    sessionStorage.setItem('purchase_tracked', transactionId);

  }, [tranCode, approvalCode, orderId, totalAmount, currency]);

  const status =
    tranCode === '000'
      ? 'Sikeres fizetés'
      : 'Sikertelen fizetés';

  let message;

  switch (tranCode) {
    case '000':
      message = 'A tranzakció jóváhagyva';
      break;
    case '101':
      message = 'A megadott kártyaparaméterek érvénytelenek';
      break;
    case '105':
      message = 'A kibocsátó bank elutasította';
      break;
    case '116':
      message = 'Fedezet hiány';
      break;
    case '130':
      message = 'Limit túllépése';
      break;
    default:
      message = 'Sikertelen fizetés: Ismeretlen hiba';
      break;
  }

  return (
    <div>
      <NavBar />
      <div className="payment-review">
        <h1 className="text-2xl font-bold">{status}</h1>

        <ul className="payment-details">
          <li>Rendelés azonosító: {orderId}</li>
          <li>Fizetési mód: Bankkártya</li>
          <li>TranCode: {tranCode}, {message}</li>
          <li>Összeg: {totalAmount} Ft</li>
          <li>Valuta: {currency}</li>
          <li>Bank jóváhagyási kód: {approvalCode}</li>
          <li>Tranzakció időpontja: {params.get('PurchaseTime')}</li>
          <li>Kártya utolsó számjegyek: {params.get('ProxyPan')}</li>
        </ul>
      </div>
    </div>
  );
};

export default PaymentReview;